import { render, staticRenderFns } from "./momentanea_upi.vue?vue&type=template&id=63e7afe7"
import script from "./momentanea_upi.vue?vue&type=script&lang=js"
export * from "./momentanea_upi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports